import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { CREATE_DOWNLOADABLE, CREATING_DOWNLOADABLE, DELETE_DOWNLOADABLE, DELETING_DOWNLOADABLE, DOWNLOADABLES_ERROR, GET_DOWNLOADABLES, GETTING_DOWNLOADABLES, UPDATE_DOWNLOADABLE, UPDATING_DOWNLOADABLE } from "../types"

export const createDownloadable = (payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_DOWNLOADABLE,
            payload: true
        })

        const response = await axios.post(`${baseUrl}/downloadables`, payload, { headers })
        
        dispatch({
            type: CREATE_DOWNLOADABLE,
            payload: response.data.data
        })
    }
    catch(error){
        dispatch({
            type: DOWNLOADABLES_ERROR,
            error
        })
    }
}

export const updateDownloadable = (id, payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: UPDATING_DOWNLOADABLE,
            payload: true
        })

        const response = await axios.patch(`${baseUrl}/downloadables/${id}`, payload, { headers })
        
        dispatch({
            type: UPDATE_DOWNLOADABLE,
            payload: response.data.data
        })
    }
    catch(error){
        dispatch({
            type: DOWNLOADABLES_ERROR,
            error
        })
    }
}

export const deleteDownloadable = (id) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: DELETING_DOWNLOADABLE,
            payload: true
        })

        const response = await axios.delete(`${baseUrl}/downloadables/${id}`, { headers })
        
        dispatch({
            type: DELETE_DOWNLOADABLE,
            payload: response.data.data
        })
    }
    catch(error){
        dispatch({
            type: DOWNLOADABLES_ERROR,
            error
        })
    }
}

export const fetchDownloadables = (filterString, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `${baseUrl}/downloadables?expand=createdBy`
        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_DOWNLOADABLES,
            payload: true
        })

        const response = await axios.get(url, { headers })
        // console.log(response.data.data)
        dispatch({
            type: GET_DOWNLOADABLES,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: DOWNLOADABLES_ERROR,
            error
        })
    }
}

export const clearCreatedDownloadable = () => async (dispatch) => {    
    try{

        dispatch({
            type: CREATE_DOWNLOADABLE,
            payload: null
        })
        
    }
    catch(error){
        dispatch( {
            type: DOWNLOADABLES_ERROR,
            error
        })
    }
}

export const clearUpdatedDownloadable = () => async (dispatch) => {    
    try{

        dispatch({
            type: UPDATE_DOWNLOADABLE,
            payload: null
        })
        
    }
    catch(error){
        dispatch( {
            type: DOWNLOADABLES_ERROR,
            error
        })
    }
}

export const clearDeletedDownloadable = () => async (dispatch) => {    
    try{

        dispatch({
            type: DELETE_DOWNLOADABLE,
            payload: null
        })
        
    }
    catch(error){
        dispatch( {
            type: DOWNLOADABLES_ERROR,
            error
        })
    }
}